/**
 * @generated SignedSource<<7e8cba65a7b79973aa80b1186a7c65b3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ProductSwitcherTaskInput = {
  masterSalesChannelID?: string | null;
  secondarySalesChannelID?: string | null;
};
export type salesChannelGenerateProductSwitcherTaskMutation$variables = {
  input: ProductSwitcherTaskInput;
};
export type salesChannelGenerateProductSwitcherTaskMutation$data = {
  readonly generateProductSwitcherTask: {
    readonly taskID: number;
  } | null;
};
export type salesChannelGenerateProductSwitcherTaskMutation = {
  response: salesChannelGenerateProductSwitcherTaskMutation$data;
  variables: salesChannelGenerateProductSwitcherTaskMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ProductSwitcherTaskOutput",
    "kind": "LinkedField",
    "name": "generateProductSwitcherTask",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "taskID",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "salesChannelGenerateProductSwitcherTaskMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "salesChannelGenerateProductSwitcherTaskMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "328ab199ffe2b4dd1d17c484905c0d33",
    "id": null,
    "metadata": {},
    "name": "salesChannelGenerateProductSwitcherTaskMutation",
    "operationKind": "mutation",
    "text": "mutation salesChannelGenerateProductSwitcherTaskMutation(\n  $input: ProductSwitcherTaskInput!\n) {\n  generateProductSwitcherTask(input: $input) {\n    taskID\n  }\n}\n"
  }
};
})();

(node as any).hash = "59e6c7c82ce26b42739099afdaf3759b";

export default node;
